module.exports = __webpack_public_path__ + "e4455da6205d61caa48b410742a4afc8.png";